@if (this.messageStatus() !== 'DISABLED') {
  @if (this.showTooltip()) {
    <button #statusButton id="{{statusIndicatorButtonId()}}" onPopover data-bs-toggle="popover" [popoverContent]="popoverContent" placement="top"
            popoverClass="pop-auto-container" class="btn btn-link link-dark p-0 hover-underline disable-browser-focus">
      <ng-container [ngTemplateOutlet]="statusContent"></ng-container>
    </button>
  } @else {
    <span class="btn btn-link link-dark p-0">
      <ng-container [ngTemplateOutlet]="statusContent"></ng-container>
    </span>
  }
  <ng-template #statusContent>
    <div class="d-inline-block" [ngClass]="noDisplayClass()">
      <app-task-message-status-icon [messageStatus]="_messageStatus" [customCssClass]="customCssClass()"></app-task-message-status-icon>
    </div>
    <div class="d-none" [ngClass]="displayClass()">
      @if (summarizeIcon()) {
        <app-task-message-status-icon [messageStatus]="_messageStatus" [customCssClass]="customCssClass()"></app-task-message-status-icon>
      } @else {
        @for (messageStatus of _messageStatuses; track messageStatus) {
          <app-task-message-status-icon [messageStatus]="messageStatus.taskStatus" [customCssClass]="messageStatus.customCssClass"></app-task-message-status-icon>
        }
      }
    </div>
    <span class="d-none d-sm-inline-block text-start">
        <ng-content></ng-content>
      </span>
  </ng-template>
}

<ng-template #popoverContent>
  <div class="w-100 h-100 text-start p-1 pe-4" [style.max-width.px]="320">
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0 mt-2 me-2">
      <button type="button" class="btn-close" data-bs-toggle="popover" aria-label="Close"></button>
    </div>
    @for (messageStatus of _messageStatuses; track messageStatus) {
      @if (messageStatus.taskStatus !== 'DISABLED') {
        <div class="mb-3 message-status">
          <span class="d-block fw-medium mb-2">{{ messageStatus.name | sentenceCase }}</span>
          <div>
            <div class="row g-2">
              @if (showSummary()) {
                <app-task-message-status [messageStatus]="messageStatus.taskStatus" [reason]="messageStatus.reason"
                                         [customLabel]="messageStatus.customLabel"
                                         [sentenceCasePipe]="messageStatus.sentenceCase"
                                         [showTooltip]="false"
                                         [customCssClass]="messageStatus.customCssClass" class="col-12"></app-task-message-status>
              }
              @for (message of messageStatus.messages; track message) {
                <div class="col-12">
                  @if (!messageStatus.hideComment) {
                    <i class="fa-light fa-fw fa-comment me-1"></i>
                  }
                  @if (messageStatus.asInnerHtml) {
                    <span [innerHTML]="message" style="line-height: 1.25rem"></span>
                  }
                  @if (!messageStatus.asInnerHtml) {
                    <span style="line-height: 1.25rem">{{ message }}</span>
                  }
                </div>
              }
              <ng-content select=".message-templates"></ng-content>
            </div>
          </div>
        </div>
      }
    }
  </div>
</ng-template>
